// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const FREDialogLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-fredialog" */ "./FREDialog")).then((bundle)=>{
        return {
            default: bundle.FREDialog
        };
    });
export const LazyFREDialog = /*#__PURE__*/ lazy(FREDialogLazyLoader);
